import React from 'react';
import 'reactflow/dist/style.css';
import HorizontalFlow from './react-flow/HorizontalFlow';

const generateTreeNodes = (data, parentId = null, depth = 0, offsetY = 0) => {
  const nodes = [];
  const edges = [];
  let idCounter = 1;

  const traverse = (node, parentId, x, y) => {
    const nodeId = `${idCounter++}`;
    const label =
      typeof node === 'object' && node !== null
        ? Array.isArray(node)
          ? 'Array'
          : 'Object'
        : String(node);

    // Add the current node
    nodes.push({
      id: nodeId,
      position: { x, y },
      data: { label },
      style: { padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' },
    });

    // Link it to its parent
    if (parentId) {
      edges.push({
        id: `e${parentId}-${nodeId}`,
        source: parentId,
        target: nodeId,
        animated: true,
      });
    }

    // Traverse child elements if it's an object or array
    if (typeof node === 'object' && node !== null) {
      const isArray = Array.isArray(node);
      const entries = isArray ? node : Object.entries(node);
      entries.forEach((child, index) => {
        const childValue = isArray ? child : child[1];
        const childKey = isArray ? `[${index}]` : child[0];
        const childLabel = isArray ? childKey : `${childKey}:`;

        // Add key labels for objects
        if (!isArray) {
          const keyId = `${idCounter++}`;
          nodes.push({
            id: keyId,
            position: { x: x + depth * 150, y: y + offsetY * 50 + index * 50 },
            data: { label: childLabel },
            style: { background: '#f3f4f6', padding: '5px', borderRadius: '3px' },
          });
          edges.push({ id: `e${nodeId}-${keyId}`, source: nodeId, target: keyId });
          traverse(childValue, keyId, x + (depth + 1) * 150, y + offsetY * 50 + index * 50);
        } else {
          traverse(childValue, nodeId, x + (depth + 1) * 150, y + offsetY * 50 + index * 50);
        }
      });
    }
  };

  traverse(data, parentId, depth * 100, offsetY);
  return { nodes, edges };
};

const TreeVisualization = ({ data }) => {
  const { nodes, edges } = generateTreeNodes(data, null, 1);
  return <HorizontalFlow propNodes={nodes} propEdges={edges} />
};

export default TreeVisualization;
